import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import { Button, InputGroup } from 'react-bootstrap';
import { MouseEventHandler } from 'react';

interface TextInputActionProps {
  label: string;
  disabled: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

interface TextInputProps {
  name: string;
  label: string;
  value: string;
  readOnly?: boolean;
  className?: string;
  actions?: TextInputActionProps[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function TextInput(props: TextInputProps) {
  const { t } = useTranslation();

  return (
    <Form.Group className={props.className || ''}>
      <Form.Label className="fw-bold" htmlFor={props.name}>
        {t(props.label)}
      </Form.Label>

      <InputGroup className={props.actions ? 'mb-3' : ''}>
        <Form.Control
          type="text"
          id={props.name}
          name={props.name}
          value={props.value}
          readOnly={props.readOnly}
          onChange={props.onChange || (() => {})}
          style={props.readOnly ? { backgroundColor: '#e9ecef' } : {}}
        />

        {props.actions &&
          props.actions.map((action, index) => (
            <Button
              key={index}
              onClick={action.onClick}
              variant="outline-secondary"
              disabled={action.disabled}
            >
              {t(action.label)}
            </Button>
          ))}
      </InputGroup>
    </Form.Group>
  );
}
